// Claves de query centralizadas + helper de invalidación tras operaciones de
// stock (que impactan inventario, movimientos, alertas, dashboard y los totales
// de productos/presentaciones).
import type { QueryClient } from '@tanstack/react-query';

export const qk = {
  bodegas: ['bodegas'] as const,
  productos: ['productos'] as const,
  presentaciones: ['presentaciones'] as const,
  inventario: ['inventario'] as const,
  movimientos: ['movimientos'] as const,
  alertas: ['alertas'] as const,
  dashboard: ['dashboard'] as const,
};

export function invalidarStock(qc: QueryClient): void {
  for (const key of [qk.inventario, qk.movimientos, qk.alertas, qk.dashboard, qk.productos, qk.presentaciones]) {
    qc.invalidateQueries({ queryKey: key });
  }
}
